// Vue
import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import { setupSentry } from '@/utils/sentry'
import { createPinia } from 'pinia'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import PrimeVue from 'primevue/config'

// third party
import JsonSchemaEditor from 'json-schema-editor-vue3'

import { createTLI18n, LANG } from '@/composables/i18n'

// Styles
import './styles/main.sass'

// Router
import router from '@/router'
import { setRouter } from '@/utils/router'

// Global components
import components from '@/components/atoms/'
import App from './App.vue'
import { getThemeConfig, installPrimeTools } from './styles/theme/install'
import { tlPrimePresetV1 } from '@/styles/theme/primeThemeConfig.v1'
import ToastService from 'primevue/toastservice'

// polyfills
import { usePolyfills } from './modules/polyfills/use-polyfills'

usePolyfills()

createTLI18n(LANG.EN)

const app = createApp(App)
const head = createHead()
const pinia = createPinia()

setupSentry(app)

app.use(head)

app.use(router)
setRouter(router)

app.use(components)
app.use(pinia)
app.use(VueDOMPurifyHTML)
app.use(JsonSchemaEditor)

app.use(PrimeVue, { theme: getThemeConfig(tlPrimePresetV1) })
app.use(ToastService)
installPrimeTools(app)

app.mount('#app')
